import $ from 'jquery';
import * as libphonenumber from 'libphonenumber-js';
export class PhoneInput {
	constructor (input) {
		this.input = input;
		this.input.on('focus', this.onFocus.bind(this));
		this.input.on('change', this.onChange.bind(this));
		this.currentPrefix = null;
		this.currentCountry = null;
		this.userForcedValid = false;
	}
	
	onChange (event) {
		this.userForcedValid = false;
		if (!this.currentPrefix || this.currentPrefix == "") {
			return;
		}
		let val = this.input.val();
		if (val.startsWith('00')) {
			this.input.val(val.replace(/^00/, '+'));
		} else if (val.startsWith('0')) {
			this.input.val(val.replace(/^0/, this.currentPrefix));
		} else if (this.currentPrefix.length > 1 && val.startsWith(this.currentPrefix.substr(1))) {
			this.input.val("+" + val);
		} else if (!val.startsWith('+')) {
			this.input.val(this.currentPrefix + val);
		}
	}
	
	onFocus (event) {
		if (this.input.val() == '') {
			this.input.val(this.currentPrefix)
		}
	}
	
	setCountry (country) {
		this.currentCountry = country;
		//if (this.prefixes) {
		// if (libphonenumber) {
			var doUpdate = (this.input.val() == this.currentPrefix);
			if (libphonenumber.isSupportedCountry(country)) {
				this.currentPrefix = '+' + libphonenumber.getCountryCallingCode(country);
			} else {
				this.currentPrefix = '+';
			}
			if (doUpdate && this.currentPrefix) {
				this.input.val(this.currentPrefix);
			}
		//}
	}
	
	setUserForcedValid() {
		this.userForcedValid = true;
	}
	
	isValid() {
		if (this.userForcedValid) {
			return true;
		}
		if (!libphonenumber.isSupportedCountry(this.currentCountry)) {
			return true;
		}
		try {
			let val = this.input.val();
			return new libphonenumber.parsePhoneNumberWithError(val, this.currentCountry).isPossible();
		} catch (error) {
			if (error instanceof libphonenumber.ParseError) {
				return false;
			} else {
				throw error;
			}
		}
	}
}